// constants from https://github.com/pnorental/conti/blob/master/src/conti/consts.go 

const conditions = {
    "NORMAL_WEAR": "Normal Wear",
    "ABNORMAL_WEAR_ONE_SIDE": "Abnormal Wear",
    "SIDEWALL_SCUFFING": "Sidewall Scuffing",
    "TREAD_DAMAGE": "Tread Damage",
    "PUNCTURE": "Puncture",
    "EXPOSED_STEEL_CORDS": "Exposed Steel Cords",
}

export const Conditions = { ...conditions };

export const Condition = function (category) {
    return conditions[category] ? conditions[category] : category
}
